import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

// Services
import { AppConfigService } from '../../app-config.service';
import { ConfigMeta, ConfigurationService } from '@oel/js-configuration';

@Injectable()
export class BffCommunicationService {
  private readonly headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private readonly headersGET = new HttpHeaders({
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Content-Type': 'application/json',
    Expires: '0',
    Pragma: 'no-cache',
    'x-desj-envsoa': 'envsoa'
  });

  private mpmJwt: string;

  constructor(private readonly _httpClient: HttpClient, private readonly _appConfigService: AppConfigService) {}

  private get urlApi() {
    const passApiUrl = ConfigurationService.getConfig(ConfigMeta.OEL_PAAS_API_URL);
    return passApiUrl ? passApiUrl : null;
  }

  /**
   * @description Filtrer appele GET au BFF pour enchainer urlAPI au debut de l'endpoint du BFF + headers conforme.
   * @param url
   */
  getJSONBFF(url: string): Observable<Object> {
    return this._httpClient.get(this.urlApi + url, {
      headers: this.headersGET
    });
  }

  /**
   * @description Filtrer appele GET au BFF pour enchainer urlAPI au debut de l'endpoint du BFF + headers conforme + parametres.
   * @param url
   * @param parametres
   */
  getJSONBFFParams(url: string, parametres: HttpParams): Observable<Object> {
    return this._httpClient.get(this.urlApi + url, {
      params: parametres,
      headers: this.headersGET
    });
  }

  /**
   * @description Filtrer appele GET au BFF pour enchainer urlAPI au debut de l'endpoint du BFF + headers conforme + type reponse de 'text'.
   * @param url
   * @param token
   */
  getTxtBFF(url: string, token: string): Observable<string> {
    if (!token) {
      return this._httpClient.get(this.urlApi + url, {
        responseType: 'text'
      });
    }

    return this._httpClient.get(this.urlApi + url, {
      responseType: 'text',
      headers: new HttpHeaders({
        // inserer token
        'X-AuthMF-Token': token
      })
    });
  }

  /**
   * @description Filtrer appele POST au BFF pour enchainer urlAPI au debut de l'endpoint du BFF + headers conforme + body a envoyer.
   * @param url
   * @param body
   */
  postJSONBFF(url: string, body: string | Object): Observable<Object> {
    return this._httpClient.post(this.urlApi + url, body, {
      headers: this.headers
    });
  }

  /**
   * @description Filtrer appele PUT au BFF pour enchainer urlAPI au debut de l'endpoint du BFF + headers conforme + body a envoyer (optionnel).
   * @param url
   * @param body
   */
  putJSONBFF(url: string, body?: string | Object): Observable<Object> {
    const bodyAEnvoyer = body ? body : JSON.stringify({});
    return this._httpClient.put(this.urlApi + url, bodyAEnvoyer, {
      headers: this.headers
    });
  }

  deleteBFF(url: string): Observable<Object> {
    return this._httpClient.delete(this.urlApi + url, {
      headers: this.headers
    });
  }

  getPdfBFF(url: string): Observable<ArrayBuffer> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    return this._httpClient.get(this.urlApi + url, { headers: headers, responseType: 'arraybuffer' });
  }

  /**
   * postForm currently used to post image in multipart-data form
   */
  postForm(url: string, formData: FormData): Observable<Object> {
    return this._httpClient.post<any>(this.urlApi + url, formData);
  }

  /**
   * Get photo of the property to build the download url using an authorized call to the bff pasing by the PISE (Auth0)
   */
  getPropertiyPhoto(url: string): Observable<Blob> {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'image/*');

    return this._httpClient.get(this.urlApi + url, { headers: headers, responseType: 'blob' });
  }

  /**
   * Wrapper for the properties, this has been added in case that we need to validate something in the jwt
   * @param value
   */
  public setMpmJwt(value) {
    this.mpmJwt = value;
  }

  /**
   * Wrapper for the properties
   *
   */
  public getMpmJwt() {
    return this.mpmJwt;
  }

  /**
   * Fetch the generated mpm jwt for the headers
   * @param token
   */
  public fetchAndSetMpmJwtForHeader(token: string): Promise<boolean> {
    const url = `/api/securite/otp`;
    return new Promise<boolean>(resolve => {
      this.getTxtBFF(url, token).subscribe((jwt: string) => {
        this.setMpmJwt(jwt);

        resolve(true);
      });
    });
  }
}
